<template>
  <div></div>
</template>

<script>
import {SERVICE_CONTENT, SERVICE_DIRECT_MESSAGE} from "@/properties/micro-service";
import {httpMixin} from "@/mixin/http-mixin";
import {geDecodedToken} from "@/common/http-common";
import {ACCESS_TOKEN} from "@/properties/close-friend";

export default {
  name: "PendingCustomRequests",
  mixins: [httpMixin],
  data() {
    return {
      pendingCustomRequests: 0,
    }
  },
  created() {
    let userId = geDecodedToken(ACCESS_TOKEN).id;
    //Get pending custom request count
    let url = `${SERVICE_CONTENT}/api/v1/customers/${userId}/custom-request/count`;
    this.getData(url, (count) => {
      this.pendingCustomRequests = count;
      if (count > 0) {
        this.$emit('pendingCustomRequests', count)
      }
    });
  }
}
</script>

<style scoped>
@media only screen and (max-width: 1023px){

  .custom-mobile-responsive{
    width: 100%;
  }
  .custom-mobile-button
  {
    /*margin-top: 3%;*/
  }
}
.alert-btn2{
  float: right;
  position: absolute;
  right: 6px;
  /*top: 5px;*/
  border-radius: 10px;
  border: none;
  padding: 8px 15px;
}
.black-text{
  color: #000 !important;
}
.warning-text{
  color: #664d03 !important;
}
.p-cls{
  margin-bottom: 0px !important;
}
</style>
